<template>
  <div class="p-3 bg-white">
    <shared-auto-call-system-public-export-data
      @exportSuccess="closePopup"
      @reUploadSuccess="reUploadSuccess"
    ></shared-auto-call-system-public-export-data>

    <div class="text-center">
      <vs-button id="reUploadButton" class="m-2" color="primary" type="filled" @click.prevent="submitReUpload">{{ $t('reupload') }}</vs-button>
      <vs-button id="exportButton" class="m-2" color="primary" type="filled" @click.prevent="submitExport">{{ $t('export') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="closePopup">{{ $t('cancel') }}</vs-button>
    </div>

  </div>
</template>

<script>
import SharedAutoCallSystemPublicExportData from '@/views/Shared/AutoCallSystemPublic/ExportData'
import { EventBus } from '@/../eventbus.js'
import SharedAutoCallSystemUploadData from '@/views/Shared/AutoCallSystemPublic/UploadData'

export default {
  name: 'Window.AutoCallSystemPublic.ExportData',
  components: {
    SharedAutoCallSystemUploadData,
    SharedAutoCallSystemPublicExportData
  },
  methods: {
    submitExport () {
      EventBus.$emit('initExportAutoCallSystemPublicData')
    },
    submitReUpload () {
      EventBus.$emit('initReUploadAutoCallSystemPublicData')
    },
    closePopup () {
      window.close()
    },
    reUploadSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_auto_call_system_public_table')
      // window.close()
    }
  }
}
</script>

<style lang="scss">
#reUploadButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
